import type { ParteDaOperacao } from '../servicos/operacao';

/**
 * Uma linha por contrato na etapa pedida — não uma por cliente.
 *
 * O sino conta contratos ("7 aguardando o fornecedor"). Filtrar pelo status da
 * linha, que é o de um contrato só (o atual do ano mais recente), escondia o
 * contrato de um ano anterior e o do segundo fornecedor do mesmo ano: o aviso
 * dizia 7 e a tela mostrava 2. Cada contrato vira a sua linha, com o ano e o
 * fornecedor dele.
 */
export function porContrato(
  itens: readonly ParteDaOperacao[],
  situacao: string,
): ParteDaOperacao[] {
  return itens.flatMap((i) =>
    // API antiga, sem a lista: o recorte de antes.
    i.contratosAtivos === undefined
      ? i.statusContrato === situacao
        ? [i]
        : []
      : i.contratosAtivos
          .filter((k) => k.status === situacao)
          .map((k) => ({
            ...i,
            statusContrato: k.status,
            anoContrato: k.ano,
            fornecedor: k.fornecedor,
            chaveDaLinha: `${i.businessId}:${k.ano}:${k.mes}:${k.fornecedor ?? ''}`,
          })),
  );
}
